/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Undo16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zM6.683 3.743a.59.59 0 01.596.595c0 .17-.07.317-.186.418l-.78.75-.58.449.827-.04h2.289c1.817 0 3.147 1.229 3.147 3.085 0 1.856-1.442 3-3.267 3H7.654C7.268 12 7 11.79 7 11.404c0-.387.276-.604.647-.604h1.082c1.114 0 2.022-.64 2.022-1.8 0-1.129-.812-1.909-1.902-1.909h-2.29l-.827-.038.449.324.92.859c.124.1.178.263.178.41a.59.59 0 01-1.005.433L4.209 6.968A.664.664 0 014 6.496c0-.186.077-.356.209-.487L6.266 3.92a.545.545 0 01.417-.178z"
        />
    </AccessibleSVG>
);

export default Undo16;
